<div class="container-fluid px-4 border-bottom">
    <div class="d-flex flex-fill align-items-center">
        <div class="me-2">
            <button
                sfHeaderToggler
                [sfSidebarToggle]="sidebarId()"
                toggle="visible"
                aria-label="Toggle navigation"
                class="btn header-toggler"
                style="margin-inline-start: -14px"
                type="button">
                <fa-icon [icon]="['fas', 'bars']"></fa-icon>
            </button>
        </div>
        <div>
            <sf-breadcrumb-router></sf-breadcrumb-router>
        </div>
        <div class="ms-auto">
            <div class="d-flex flex-row align-items-center gap-2">
                @if (appStore.me()?.companyName) {
                    <p class="fw-thin mb-0 d-none d-sm-block">{{ appStore.me()?.companyName }}</p>
                }
                <button sfButton size="sm" icon="robot" (click)="toggleAiPanel()"></button>
            </div>
        </div>
    </div>
</div>

@if (showAiPanel()) {
    <sf-ai-chat-panel [initialPrompt]="initialPrompt()" (closed)="closeAiPanel()"></sf-ai-chat-panel>
}
